window.addItem = function addItem(variantId, options = {}) {
  const shouldRefresh = options.refresh !== false;
  const normalizedVariantId = Number(variantId);

  if (!Number.isFinite(normalizedVariantId) || normalizedVariantId <= 0) {
    return Promise.reject(new Error('Invalid cart variant'));
  }

  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      items: [{ id: normalizedVariantId, quantity: 1 }]
    }),
  })
    .then((response) => {
      if (!response.ok) return response.json().catch(() => ({})).then(data => {
        throw new Error(data.description || data.message || 'Unable to add item');
      });
      return response.json();
    })
    .then(async (data) => {
      invalidateCartCache();
      if (shouldRefresh) {
        if (typeof window.ShopSanteRefreshCart === 'function') {
          await window.ShopSanteRefreshCart();
        } else if (typeof window.refreshCart === 'function') {
          window.refreshCart();
        }
      }
      return data;
    });
};

window.clearCart = function clearCart(variantIds, callback) {
  const items = {};
  [...new Set(variantIds.map(String))].forEach(element => (items[element] = 0));

  if (Object.keys(items).length === 0) {
    if (callback) callback();
    return Promise.resolve(null);
  }

  return fetch('/cart/update.js', {
    method: 'POST',
    credentials: "same-origin",
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates: items })
  })
    .then((response) => {
      if (!response.ok) throw new Error(`Unable to update cart (${response.status})`);
      return response.json();
    })
    .then((data) => {
      commitCartData(data);
      if (callback) callback();
      return data;
    })
    .catch(err => {
      console.error('Unable to clear cart items', err);
      throw err;
    });
};

let cartData = null;
let cartRequest = null;
let cartDataVersion = 0;

function invalidateCartCache() {
  cartDataVersion += 1;
  cartData = null;
  cartRequest = null;
}

function commitCartData(data) {
  cartDataVersion += 1;
  cartRequest = null;
  cartData = data;
  return data;
}

function getCart() {
  if (cartRequest) return cartRequest;

  const requestVersion = cartDataVersion;
  const request = fetch('/cart.js', {
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json' }
  })
    .then(response => response.json())
    .then(data => {
      if (requestVersion === cartDataVersion) cartData = data;
      return data;
    })
    .catch(() => {
      if (requestVersion === cartDataVersion) cartData = null;
      return null;
    })
    .finally(() => {
      if (cartRequest === request) cartRequest = null;
    });

  cartRequest = request;
  return request;
}

window.ShippingBar = function ShippingBar() {
  var items = document.querySelectorAll(".cart-rewards .progress_bar .progress_bar_item");

  items.forEach(function (item) {
    var progressBar = item.querySelector(".cart-rewards .progress");
    if (!progressBar) return;

    var itemValue = Math.max(0, Math.min(100, Number(progressBar.dataset.progress) || 0));

    if (progressBar.classList.contains('progress--no-animate')) {
      progressBar.style.width = itemValue + "%";
    } else {
      progressBar.style.width = "0%";
      requestAnimationFrame(function () {
        progressBar.style.width = itemValue + "%";
      });
    }
  });
};

ShippingBar();

window.checkShoppingInsurance = function checkShoppingInsurance() {
  const inputs = Array.from(document.querySelectorAll('.cart-shipping-insurance input[data-product]'));
  if (inputs.length === 0) return;

  const setState = (variantId, checked, state = 'idle', detail = '') => {
    document.querySelectorAll(`.cart-shipping-insurance input[data-product="${variantId}"]`).forEach(input => {
      input.checked = checked;
      input.disabled = state === 'saving';
      input.setAttribute('aria-busy', state === 'saving' ? 'true' : 'false');
      const card = input.closest('.cart-shipping-insurance');
      if (!card) return;

      if (state === 'idle') card.removeAttribute('data-state');
      else card.dataset.state = state;

      if (detail) card.dataset.errorDetail = detail;
      else delete card.dataset.errorDetail;

      const status = card.querySelector('[data-shipping-insurance-status]');
      if (!status) return;

      status.classList.toggle('hidden', state === 'idle');
      if (state === 'saving') status.textContent = card.dataset.savingLabel || '…';
      if (state === 'error') status.textContent = card.dataset.errorLabel || 'Unable to update';
    });
  };

  inputs.forEach(input => {
    const variantId = parseInt(input.getAttribute('data-product'), 10);
    if (!Number.isFinite(variantId) || variantId <= 0) {
      input.disabled = true;
      input.setAttribute('aria-disabled', 'true');
      return;
    }

    if (input.dataset.insuranceHandled === 'true') return;
    input.dataset.insuranceHandled = 'true';

    input.addEventListener('change', async function () {
      const shouldBeChecked = this.checked;
      setState(variantId, shouldBeChecked, 'saving');

      try {
        if (shouldBeChecked) {
          await addItem(variantId);
          invalidateCartCache();
          const updatedCart = await getCart();
          if (!updatedCart?.items?.some(item => item.id === variantId)) {
            throw new Error('Shipping insurance was not added to the cart');
          }
        } else {
          await clearCart([variantId]);
          if (typeof window.ShopSanteRefreshCart === 'function') {
            await window.ShopSanteRefreshCart();
          } else if (typeof window.refreshCart === 'function') {
            window.refreshCart();
          }
        }
        setState(variantId, shouldBeChecked, 'idle');
      } catch (error) {
        setState(variantId, !shouldBeChecked, 'error', error.message || String(error));
        console.error('Unable to update shipping insurance', error);
      }
    });
  });

  getCart().then(cart => {
    if (!cart) return;
    inputs.forEach(input => {
      const variantId = parseInt(input.getAttribute('data-product'), 10);
      if (!Number.isFinite(variantId)) return;
      setState(variantId, cart.items.some(item => item.id === variantId), 'idle');
    });
  });
};

window.checkGiftProduct = function checkGiftProduct(callback) {
  if (!window.giftProduct) return;

  if (window.__checkingGiftProduct) return;
  window.__checkingGiftProduct = true;

  getCart()
    .then(() => {
      if (!cartData) return;

      const item = cartData.items.find(item => item.id === window.giftProduct);

      if (item) {
        if (cartData.item_count === 1 || cartData.total_price === 0) {
          return clearCart([window.giftProduct], callback);
        }
      } else if (cartData.total_price > 0) {
        return fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ quantity: 1, id: window.giftProduct }),
        }).then(() => {
          if (callback) callback();
        });
      }
    })
    .finally(() => {
      window.__checkingGiftProduct = false;
    });
};

window.displayDonationMessageCartDrawer = function displayDonationMessageCartDrawer() {
  getCart()
    .then(cart => {
      if (!cart) return;

      const container = document.querySelector(".movember-container");

      if (container) {
        container.style.display = cart.total_price >= 2000 ? 'flex' : 'none';
      }
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
};

window.setupFlavourSubstitution = function setupFlavourSubstitution() {
  const inputs = Array.from(document.querySelectorAll('[data-flavour-substitution]'));
  const legacyNote = '🔄 user agrees to receive a different flavour';

  if (inputs.length === 0) return;

  const attributeKey = inputs[0].dataset.flavourAttributeKey;
  const attributeValue = inputs[0].dataset.flavourAttributeValue;
  const cartRoot = window.Shopify?.routes?.root || '/';

  function setVisualState(enabled, state = 'saved') {
    document.querySelectorAll('[data-flavour-substitution]').forEach(input => {
      input.checked = enabled;
      input.disabled = state === 'saving';
      input.setAttribute('aria-busy', state === 'saving' ? 'true' : 'false');
    });

    document.querySelectorAll('[data-flavour-substitution-card]').forEach(card => {
      card.dataset.state = state;
      card.classList.toggle('is-selected', enabled);

      const status = card.querySelector('[data-flavour-substitution-status]');
      if (!status) return;

      status.classList.toggle('hidden', !enabled && state !== 'error');
      if (state === 'saving') status.textContent = card.dataset.savingLabel || '…';
      if (state === 'error') status.textContent = card.dataset.errorLabel || 'Unable to save';
      if (state === 'saved') status.textContent = status.dataset.savedLabel || status.textContent;
    });
  }

  function updateAttribute(enabled, options = {}) {
    const payload = {
      attributes: {
        [attributeKey]: enabled ? attributeValue : ''
      }
    };

    if (options.clearLegacyNote) payload.note = '';

    return fetch(`${cartRoot}cart/update.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(response => {
        if (!response.ok) throw new Error('Unable to update flavour substitution preference');
        return response.json();
      })
      .then(data => {
        commitCartData(data);
        return data;
      });
  }

  getCart()
    .then(() => {
      if (!cartData) return;

      const storedValue = cartData.attributes?.[attributeKey] || '';
      const hasLegacyChoice = cartData.note?.trim() === legacyNote;

      if (!storedValue && hasLegacyChoice) {
        setVisualState(true, 'saving');
        return updateAttribute(true, { clearLegacyNote: true })
          .then(() => setVisualState(true, 'saved'))
          .catch(error => {
            console.error(error);
            setVisualState(true, 'error');
          });
      }

      setVisualState(Boolean(storedValue), 'saved');
    });

  inputs.forEach(input => {
    if (input.dataset.flavourSubstitutionHandled === 'true') return;
    input.dataset.flavourSubstitutionHandled = 'true';

    const status = input.closest('[data-flavour-substitution-card]')?.querySelector('[data-flavour-substitution-status]');
    if (status && !status.dataset.savedLabel) status.dataset.savedLabel = status.textContent.trim();

    input.addEventListener('change', function () {
      const enabled = this.checked;
      setVisualState(enabled, 'saving');

      updateAttribute(enabled)
        .then(() => setVisualState(enabled, 'saved'))
        .catch(error => {
          console.error(error);
          setVisualState(!enabled, 'error');
        });
    });
  });
};

// Backward-compatible name used by the existing cart refresh lifecycle.
window.addCartNote = window.setupFlavourSubstitution;

window.cartSliderFormSubmit = function cartSliderFormSubmit(form, giftProducts) {
  document.querySelectorAll(form).forEach(form => {
    if (form.dataset.cartSliderHandled === 'true') return;
    form.dataset.cartSliderHandled = 'true';

    const handleSubmission = async function (event) {
      event.preventDefault();
      if (window.__giftMutationInProgress) return;

      const productSelect = this.querySelector('select');
      const selectedOption = productSelect?.selectedOptions?.[0];
      const upsellItem = this.closest('upsell-item');
      const submitButton = event.submitter || upsellItem?.querySelector('button[type="submit"]');
      const loader = document.querySelector('.loader-container');

      if (!productSelect || !selectedOption || selectedOption.disabled || upsellItem?.hidden) return;
      if (typeof upsellItem?.isVariantSelectable === 'function' && !upsellItem.isVariantSelectable(productSelect.value)) return;

      this.closest('[data-product-select]')?.querySelector('[data-gift-inline-error]')?.remove();

      const showError = (message) => {
        const card = this.closest('[data-product-select]');
        if (!card) return;
        let error = card.querySelector('[data-gift-inline-error]');
        if (!error) {
          error = document.createElement('p');
          error.className = 'cart-upsell-item__inline-error';
          error.dataset.giftInlineError = '';
          card.querySelector('.cart-upsell-item__body')?.append(error);
        }
        error.textContent = message;
      };

      window.__giftMutationInProgress = true;
      loader?.classList.add('active');
      submitButton?.classList.add('working');
      submitButton?.setAttribute('aria-busy', 'true');

      try {
        const cart = await getCart();
        const threshold = Number(upsellItem?.dataset.upsellThreshold || 0);
        const renderedCartTotal = Number(upsellItem?.dataset.upsellCartTotal || 0);
        const liveCartTotal = cart && Number.isFinite(Number(cart.total_price))
          ? Number(cart.total_price) / 100
          : renderedCartTotal;

        if (liveCartTotal < threshold) {
          throw new Error(document.documentElement.lang?.startsWith('fr')
            ? `Ajoutez encore des produits pour atteindre ${threshold.toFixed(2)} $.`
            : `Add more products to reach $${threshold.toFixed(2)}.`);
        }

        if (giftProducts === true) {
          window.upsellProductsIDs = window.upsellProductsIDs || [];
          await clearCart(window.upsellProductsIDs);
        }

        await addItem(productSelect.value);
      } catch (error) {
        console.error('Unable to add free gift', error);
        showError(error.message || (document.documentElement.lang?.startsWith('fr')
          ? 'Cette gratuité n’est plus disponible. Choisissez une autre saveur.'
          : 'This free gift is no longer available. Choose another flavour.'));
      } finally {
        window.__giftMutationInProgress = false;
        loader?.classList.remove('active');
        submitButton?.classList.remove('working');
        submitButton?.removeAttribute('aria-busy');
      }
    };

    form.addEventListener('submit', handleSubmission);

    // Some dynamically refreshed cart drawers do not reliably submit a form
    // when its button lives outside the <form> and points to it by ID.
    const associatedButton = form.closest('upsell-item')?.querySelector('button[type="submit"]');
    if (associatedButton && associatedButton.dataset.giftSubmitHandled !== 'true') {
      associatedButton.dataset.giftSubmitHandled = 'true';
      associatedButton.addEventListener('click', event => {
        event.preventDefault();
        handleSubmission.call(form, {
          preventDefault() {},
          submitter: associatedButton
        });
      });
    }
  });
};

window.cartSliderSelect = function cartSliderSelect(select) {
  document.querySelectorAll(select).forEach(select => {
    if (select.dataset.cartSliderSelectHandled === 'true') return;
    select.dataset.cartSliderSelectHandled = 'true';

    select.addEventListener("change", function (event) {
      event.preventDefault();

      const selectedOption = this.selectedOptions?.[0];
      if (!selectedOption || selectedOption.disabled) return;

      const imgUrl = selectedOption.getAttribute('data-upsell-image');
      const variantPrice = selectedOption.getAttribute('data-upsell-price');
      const variantComparePrice = selectedOption.getAttribute('data-upsell-compare-price');
      const productCard = this.closest('[data-product-select]');

      if (imgUrl && imgUrl !== 'undefined') {
        const img = productCard?.querySelector('img');

        if (img) {
          img.src = imgUrl;
          img.srcset = '';
        }
      }

      const price = productCard?.querySelector('[data-price] span');
      const comparePrice = productCard?.querySelector('[data-price] del');
      if (price && variantPrice && variantPrice !== 'undefined') price.innerText = variantPrice;
      if (comparePrice && variantComparePrice && variantComparePrice !== 'undefined') comparePrice.innerText = variantComparePrice;
    });
  });
};

window.removeIneligibleGifts = function removeIneligibleGifts() {
  const keys = [...new Set(
    Array.from(document.querySelectorAll('[data-delete-gift]'))
      .map(item => item.getAttribute('data-delete-gift'))
      .filter(Boolean)
  )];

  if (keys.length === 0 || window.__removingIneligibleGifts) return Promise.resolve();

  const updates = {};
  keys.forEach(key => { updates[key] = 0; });
  window.__removingIneligibleGifts = true;

  return fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ updates })
  })
    .then(response => {
      if (!response.ok) throw new Error(`Unable to remove ineligible gift (${response.status})`);
      return response.json();
    })
    .then(data => {
      commitCartData(data);
      refreshCart();
    })
    .catch(error => console.error('Unable to remove ineligible gift', error))
    .finally(() => {
      window.__removingIneligibleGifts = false;
    });
};

window.InitSubmit = function InitSubmit() {
  cartSliderFormSubmit(".cart-gift-product form.upsell", true);
  cartSliderSelect(".cart-gift-product form.upsell select");

  removeIneligibleGifts();

  ShippingBar();
  checkShoppingInsurance();
  addCartNote();

  clearTimeout(window.__giftProductCheckTimer);
  window.__giftProductCheckTimer = setTimeout(() => {
    checkGiftProduct();
  }, 600);
};

if (document.querySelector('body.template-cart') !== null) {
  InitSubmit();

  clearTimeout(window.__giftProductCheckTimer);
  window.__giftProductCheckTimer = setTimeout(() => {
    checkGiftProduct();
  }, 600);
}
